(ns bec-cljs-common.url
  (:require [taoensso.timbre :as log]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [ajax.core :as ajax :refer [json-request-format json-response-format]]
            [clojure.core.async :as async]
            [lambdaisland.uri :as uri]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.worker :as bcc.worker]
            [bec-cljs-common.re-frame :as bcc.rf]
            [bec-cljs-common.state-sync-client :as bcc.ssc]))


;; TODO: This is obviously not complete or anything --- consider building on or enabling users to attach to:
;;  - https://github.com/clj-commons/pushy
;;  - https://github.com/venantius/accountant
;; ..and so on.


(defn sync! []
  (rf/dispatch [::bcc.ssc/patch! #(assoc-in % (config/path :nursery :bec-clj-common :viewport config/viewport-id)
                                            {:id config/viewport-id, :bec-device-id config/device-id
                                             :url {:query (-> (uri/parse js/location.search)
                                                              (uri/query-map))}})]))
